import { Link } from 'react-router-dom';
import { useBlockMedia } from './useBlockMedia';
import { MediaImage } from '../components/ui';

interface ImageBannerData {
  eyebrow?: string;
  heading?: string;
  linkLabel?: string;
  linkHref?: string;
  mediaId?: string;
  height?: number;
}

/** Full-bleed photograph with a left-to-right scrim and copy anchored left. */
export function ImageBannerBlock({ data }: { data: ImageBannerData }) {
  const media = useBlockMedia(data.mediaId);

  return (
    <section className="sz-banner" style={{ height: data.height ? `${data.height}px` : undefined }}>
      <MediaImage
        media={media}
        alt=""
        className="sz-banner__media"
        placeholder="Full room, warm brass fixtures"
        sizes="100vw"
      />
      <div className="sz-banner__overlay">
        <div className="sz-banner__copy">
          {data.eyebrow && <p className="sz-eyebrow">{data.eyebrow}</p>}
          {data.heading && <h2 className="sz-banner__heading">{data.heading}</h2>}
          {data.linkHref && data.linkLabel && (
            <Link to={data.linkHref} className="sz-banner__link">
              {data.linkLabel}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
